export default "__VITE_ASSET__CXCxMj5p__"